import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18n from "i18n";
import { AIAgentSuggestions } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { SUGGESTIONS_QUERY_KEY } from "../api/Suggestions";
const useDismissSuggestion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (suggestionId) => AIAgentSuggestions.dismiss(suggestionId),
    onSuccess: () => {
      UserNotification.success(
        i18n.t("notifications.suggestion_dismissed", { ns: "enterprise_ai" }),
        i18n.t("notifications.suggestions_title", { ns: "enterprise_ai" })
      );
      queryClient.invalidateQueries({ queryKey: SUGGESTIONS_QUERY_KEY });
    },
    onError: (e) => {
      UserNotification.error(
        i18n.t("notifications.suggestion_dismiss_failed", { ns: "enterprise_ai", message: e.message }),
        i18n.t("notifications.suggestions_title", { ns: "enterprise_ai" })
      );
    }
  });
};
export default useDismissSuggestion;
